import Swal from 'sweetalert2';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';
import toast from 'react-hot-toast';

const base_url = process.env.REACT_APP_API_URL;

const PromoCodeManagement = () => {
  const { user_phone } = useParams();
 const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [promoCode, setPromoCode] = useState('');
  const [amount, setAmount] = useState('');
  const [percentage, setPercentage] = useState('');
  const [activeFrom, setActiveFrom] = useState(new Date().toISOString().split('T')[0]);
  const [validTill, setValidTill] = useState('');
  const [promoCodes, setPromoCodes] = useState([]);
  const [filter, setFilter] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [createdBy, setCreatedBy] = useState(localStorage.getItem('adminUser') || 'Admin');
  const [dateValues, setDateValues] = useState({});

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const from = new Date(activeFrom);
    const to = new Date(from);
    to.setDate(to.getDate() + 30);
    setValidTill(to.toISOString().split('T')[0]);
  }, [activeFrom]);

  useEffect(() => {
    fetchPromoCodes();
  }, []);

  const fetchPromoCodes = async () => {
    try {
      const res = await axios.get(`${base_url}/admin/fetchPromoCode`);
      console.log("Promod oc dnis ", res.data);
      setPromoCodes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreatePromo = async () => {
    if (!promoCode || (!amount && !percentage)) {
      toast.error('Enter promo code and either amount or percentage.');
      return;
    }

    try {
      const auth = localStorage.getItem('admin');
      const response = await axios.post(`${base_url}/webapi/admin/promocode`, {
        code: promoCode,
        admin: auth,
        amount: amount ? parseFloat(amount) : null,
        percentage: percentage ? parseFloat(percentage) : null,
        activeFrom,
        validTill,
        createdBy,
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setPromoCode('');
        setAmount('');
        setPercentage('');
        fetchPromoCodes();
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const action = currentStatus ? 'deactivate' : 'activate';
    const result = await Swal.fire({
      title: `Are you sure you want to ${action} this promo code?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Yes, ${action} it!`,
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        await axios.post(`${base_url}/admin/updateCodeStatus/${id}`, {
          isActive: !currentStatus,
        });
        Swal.fire('Success', `Promo code ${action}d successfully!`, 'success');
        fetchPromoCodes();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Something went wrong!', 'error');
      }
    }
  };

//  const [dateValues, setDateValues] = useState({}); // key: promo ID, value: date

const handleDateChange = (id, newDate) => {
  setDateValues((prev) => ({ ...prev, [id]: newDate }));
};

console.log("dats vaksu", dateValues);
const handleEditTillDate = (id) => {
  const newDate = dateValues[id];
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to update the Valid Till date?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, update it!',
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .put(`${base_url}/admin/updatePromoCodeDate`, { id, validTill: newDate })
        .then(() => {
          toast.success('Valid Till date updated');
          fetchPromoCodes();
        })
        .catch(() => {
          toast.error('Update failed');
        });
    }
  });
};


  const filteredPromoCodes = promoCodes.filter((p) => {
    const matchText = [p.promocode, p.createby].some(field =>
      field?.toLowerCase().includes(filter.toLowerCase())
    );

    const matchType =
      filterType === 'all' ||
      (filterType === 'percentage' && p.percentage) ||
      (filterType === 'amount' && p.amount);

    const matchStatus =
      statusFilter === 'all' ||
      (statusFilter === 'active' && p.status === 1) ||
      (statusFilter === 'inactive' && p.status === 0);

    return matchText && matchType && matchStatus;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
  <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h2 className="fw-bold">Promo Code Management</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="content p-3">
        {/* Promo Creation Card */}
        <div className="card shadow-sm p-4 mb-4 rounded-3">
          {/* <h5 className="mb-3">Create Promo Code</h5> */}
          <div className="row g-3">

            <div className="col-md-4">
                <label>Enter Promo Code</label>
              <input
                type="text"
                placeholder="Promo Code"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-md-4">
              <label>Amount  (₹)</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="form-control"
                placeholder="Optional"
              />
            </div>
            <div className="col-md-4">
              <label>Percentage  (%)</label>
              <input
                type="number"
                value={percentage}
                onChange={(e) => setPercentage(e.target.value)}
                className="form-control"
                placeholder="Optional"
              />
            </div>
            <div className="col-md-4">
              <label>Active From</label>
              <input
                type="date"
                value={activeFrom}
                onChange={(e) => setActiveFrom(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-md-4">
              <label>Valid Till</label>
              <input
                type="date"
                value={validTill}
                onChange={(e) => setValidTill(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button className="btn btn-primary w-100" onClick={handleCreatePromo}>
                Create Promo
              </button>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="card shadow-sm p-3 mb-4 rounded-3">
          <div className="row mb-3">
            <div className="col-md-6">
              <input
                type="text"
                placeholder="Search by code or creator"
                className="form-control"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex flex-wrap gap-2 mb-2">
            <button
              className={`btn btn-outline-secondary btn-sm ${filterType === 'percentage' && 'btn-primary text-white'}`}
              onClick={() => setFilterType('percentage')}
            >
              Only Percentage
            </button>
            <button
              className={`btn btn-outline-secondary btn-sm ${filterType === 'amount' && 'btn-primary text-white'}`}
              onClick={() => setFilterType('amount')}
            >
              Only Amount
            </button>
            <button
              className={`btn btn-outline-secondary btn-sm ${statusFilter === 'active' && 'btn-success text-white'}`}
              onClick={() => setStatusFilter('active')}
            >
              Active
            </button>
            <button
              className={`btn btn-outline-secondary btn-sm ${statusFilter === 'inactive' && 'btn-danger text-white'}`}
              onClick={() => setStatusFilter('inactive')}
            >
              Inactive
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="card shadow-sm p-3 rounded-3">
          <h5 className="mb-3">Promo Code List</h5>
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th>Code</th>
                  <th>Amount</th>
                  <th>Percentage</th>
                  <th>User Count</th>

                  <th>Active From</th>
                  <th>Valid Till</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredPromoCodes.length > 0 ? (
                  filteredPromoCodes.map((p) => (
                    <tr key={p.id}>
                      <td>{p.promocode}</td>
                      <td>{p.amount || '-'}</td>
                      <td>{p.percentage || '-'}</td>
                      <td>{p.count || '0'}</td>

                      <td>{new Date(p.fromdate).toLocaleDateString('en-CA')}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            style={{ maxWidth: '140px' }}
                            value={dateValues[p.id] || new Date(p.tilldate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleDateChange(p.id, e.target.value)}
                          />
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => handleEditTillDate(p.id)}
                          >
                            Save
                          </button>
                        </div>
                      </td>
                      <td>{p.createby || '-'}</td>
                      <td>
                        <span className={`badge ${p.status === 1 ? 'bg-success' : 'bg-danger'}`}>
                          {p.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => handleToggleStatus(p.id, p.status === 1)}
                        >
                          {p.status === 1 ? 'Deactivate' : 'Activate'}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No promo codes found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  </div>
);

};

export default PromoCodeManagement;
